import "jquery-ui/ui/widgets/autocomplete";

var attach_attach_autocomplete = function () {
  // rebuild after each nav. assume react is interfering with showing results after nav without this
  $(".autocomplete_search").removeClass("autocompleted");
  $(".autocomplete_search").each(function (i, e) {
    if ($(e).autocomplete("instance")) {
      $(e).autocomplete("destroy");
    }
  });
  $(document)
    .off("click focus", ".autocomplete_search")
    .on("click focus", ".autocomplete_search", function () {
      if (!$(this).hasClass("autocompleted")) {
        $(this).addClass("autocompleted");
        attach_autocomplete($(this).attr("id"), {
          search_type: $(this).attr("data-search-type"),
          cb: $(this).attr("data-cb"),
          source: $(this).attr("data-source"),
          pos: $(this).attr("data-results-pos"),
        });
      }
    });
};

// first landing (mostly for splash)
$(document).ready(attach_attach_autocomplete);
// subsequent
$(document).on("turbolinks:render", attach_attach_autocomplete);

window.attach_autocomplete = function (input_id, options) {
  $("#" + input_id)
    .autocomplete({
      position: {
        my: "left top",
        at: options.pos || "left bottom",
      },
      //    appendTo: $('#' + input_id).parent(),
      source: function (request, response) {
        window._jango = typeof _jango == "undefined" ? {} : _jango;
        _jango.cache = _jango.cache || {};

        var term = request.term;
        if (term in _jango.cache) {
          response(_jango.cache[term]);
          return;
        }

        var $this = $(this);
        var $element = $(this.element);
        var previous_request = $element.data("jqXHR");
        if (previous_request) {
          previous_request.abort();
        }

        $element.data(
          "jqXHR",
          $.getJSON(
            "/artists/jsearch",
            $.extend(request, this.options.params),
            function (data, status, xhr) {
              _jango.cache[term] = data;
              response(data);
            }
          )
        ); //data
      },
      minLength: 2,
      autoFocus: true,
      select: function (event, ui) {
        console.log("select:" + this.id);
        switch ($(this).autocomplete("option", "params").cb) {
          case "play": //listener header search
            PlayerUI.tunein(ui.item.station_id);
            break;
          case "nav": //splash
            top.location = ui.item.url;
            //Turbolinks.visit(ui.item.url);

            break;
          case "inav":
            Turbolinks.visit(ui.item.url);
            break;
          case "add": //quickmix
            window.CustomizeUI.quickmix({ id: ui.item.id });
            break;
        } //switch
        $(this).val("");
        return false;
      }, //select

      response: function (event, ui) {
        // ui.content is the array that's about to be sent to the response callback.
        if (ui.content.length === 0) {
          var mel = $("#bonkers")[0];
          if (mel) {
            $(mel).show().delay(3000).fadeOut();
          } else {
            mel = $("<div/>", {
              id: "bonkers",
              text: "No stations found. Please try again.",
            }).prependTo($("body"));

            $(mel)
              .cloneOffset("#" + event.target.id, {
                offsetTop: $(this).outerHeight() + 2,
              })
              .show()
              .delay(3000)
              .fadeOut();
          }
        }
      },
    })
    .autocomplete("option", {
      params: {
        cb: options.cb,
        source: options.source,
        search_type: options.search_type,
      },
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
    if (options.search_type == "all") {
      return $("<li>")
        .append("<div><img src='" + item.img + "' />" + item.label + "</div>")
        .appendTo(ul);
    } else {
      //default with no img
      //https://github.com/jquery/jquery-ui/blob/master/ui/widgets/autocomplete.js:566 2017-09-26
      return $("<li>").append($("<div>").text(item.label)).appendTo(ul);
    }
  };
};
